import { render, staticRenderFns } from "./CustomerListView.vue?vue&type=template&id=5ccf91b4&scoped=true"
import script from "./CustomerListView.vue?vue&type=script&lang=js"
export * from "./CustomerListView.vue?vue&type=script&lang=js"
import style0 from "./CustomerListView.vue?vue&type=style&index=0&id=5ccf91b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccf91b4",
  null
  
)

export default component.exports